import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { useSortAndFilter } from "../contexts/SortAndFilterContext";
import { StyledDiv } from "./styles";
import { messages } from "./messages";

export const FilterButton = (): JSX.Element => {
  const intl = useIntl();
  const sortAndFilterContext = useSortAndFilter();

  const handleOnClick = useCallback(() => sortAndFilterContext.apply(), [sortAndFilterContext]);

  return (
    <StyledDiv onClick={handleOnClick} role="filter">
      {intl.formatMessage(messages.filter)}
    </StyledDiv>
  );
};
